import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/navigation/Navigation';
import Home from './components/sections/Home';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
// import Games from './components/sections/Games';
import Cooking from './components/sections/Cooking';
import Resume from './components/sections/Resume';
import Footer from './components/Footer';

const Portfolio = () => (
	<div>
		<Navigation />
		<Home />
		<About />
		<Projects />
		{/* <Games /> */}
		<Cooking />
		<Footer />
	</div>
);

const App = () => (
	<BrowserRouter>
		<Routes>
			<Route path="/" element={<Portfolio />} />
			<Route path="/resume" element={<Resume />} />
		</Routes>
	</BrowserRouter>
);

export default App;
